<div
  *ngIf="!indexKeyInfo()"
  class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50"
>
  <p-progressSpinner
     styleClass="w-16 h-16"
    strokeWidth="4"
    animationDuration=".5s"
  ></p-progressSpinner>
</div>
<div *ngIf="indexKeyInfo() as ki" class="bg-gray-100 flex justify-center">
  <div class="py-6">
    <h2 class="text-lg font-bold text-gray-800 border-l-4 border-green-600 pl-2 mb-2">Key Information</h2>
    <div class="key-info-table-container flex gap-2">
      <div class="key-info-table-wrapper w-[80vw]">
        <div class="grid grid-cols-8 text-white bg-bnpp-green text-xs font-semibold text-center">
          <div class="py-2">BLOOMBERG</div>
          <div class="py-2">ASSET</div>
          <div class="py-2">STYLE</div>
          <div class="py-2">GEOGRAPHY</div>
          <div class="py-2">TYPE</div>
          <div class="py-2">CURRENCY</div>
          <div class="py-2">LAST UPDATE DATE</div>
          <div class="py-2">LAUNCH DATE</div>
        </div>
        <div class="grid grid-cols-8 text-gray-800 text-center text-sm border border-gray-200">
          <div class="py-2">{{ki.bbgCode}}</div>
          <div class="py-2">{{ki.assetClass}}</div>
          <div class="py-2">{{ki.category}}</div>
          <div class="py-2">{{ki.geography}}</div>
          <div class="py-2">{{ki.productType}}</div>
          <div class="py-2">{{ki.currency}}</div>
          <div class="py-2">{{ki.lastUpdateDate}}</div>
          <div class="py-2">{{ki.formattedLaunchDate}}</div>
        </div>
      </div>
      <bnpp-indx-index-pdf-excel-pallete [mdsCode]="mdsCode"></bnpp-indx-index-pdf-excel-pallete>
    </div>

    <div class="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-8 w-[80vw]">
      <div>
        <h3 class="text-lg font-bold text-gray-800 pl-1 mb-2">
          Objective and Strategy
        </h3>
        <div [innerHTML]="ki.objectives" class="list-disc pl-6 text-sm"></div>
      </div>
      <div *ngIf="indexCompositionInfo() as ic">
        <h3 class="text-lg font-bold text-gray-800 pl-1 mb-2">
          Composition
        </h3>
        <div class="text-right text-sm text-gray-500">Date as of {{ic[0]?.formattedCompDate}}</div>
        <div class="table-wrapper">
          <table class="max-h-5 overflow-y-auto min-w-full mt-2 border border-gray-200 text-sm text-left">
            <thead class="bg-bnpp-green text-white font-semibold">
              <tr>
                <th class="px-4 py-2">UNDERLYING</th>
                <th class="px-4 py-2">BLOOMBERG</th>
                <th class="px-4 py-2">WEIGHT</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of ic" class="border-t">
                <td class="px-4 py-2">{{item.Underlying}}</td>
                <td class="px-4 py-2">{{item.BbgCode}}</td>
                <td class="px-4 py-2">{{item.Weight}}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
